export const urlBase = process.env.REACT_APP_URL_BASE;
export const urlDirectus = process.env.REACT_APP_URL_DIRECTUS;
export const urlAPIDirectus = process.env.REACT_APP_URL_API_DIRECTUS;
export const urlAPIAgaric = process.env.REACT_APP_URL_API_AGARIC;